import styles from './index.module.scss';


export const cellStyles = {
    cell: styles.cell,
    last: styles.last,
    first: styles.first,
};
